import React from 'react';
import { Box, Typography } from '@mui/material';

const NotAuthorized = () => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Typography variant="h4" color="error">
        You do not have permission to view this page.
      </Typography>
    </Box>
  );
};

export default NotAuthorized;